import { MARKER_ANCHOR } from 'components/Map/NewJobMarkers/utils/markerConstants';
import { createMarkerPopup } from 'components/Map/NewJobMarkers/utils/markerPopupUtils';
import { createStopPopup } from './stopPopupBuilder';
import { createStopTapHandler } from '../../utils/markerTapHandler';

const attachStopTap = createStopTapHandler((data) => data?.jobOrder);

export function attachStopHoverEvents(marker, translationsRef, map, dispatch, displayRef) {
  createMarkerPopup(marker, map, MARKER_ANCHOR.STOP.y, (data) => {
      return createStopPopup(data, translationsRef.current);
  });
  attachStopTap(marker, dispatch, displayRef);
}
